import type {Theme} from '@/store/theme';

/** Browser-chrome colour per theme (address bar / status bar). */
const THEME_COLOR: Record<Theme, string> = {
  dark: '#0b0c10',
  light: '#f3f2ef',
};

/**
 * Reflect the active theme onto `<html>`: toggle the `dark` / `light` classes
 * (the `dark` class drives Tailwind's `dark:` variant and the shadcn `.dark`
 * token block; scoped wrappers key their light overrides off `.light`) and
 * update the `theme-color` meta.
 *
 * The pre-hydration inline script in `index.html` performs the equivalent
 * class assignment before first paint; this keeps it in sync on every toggle.
 */
export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  root.classList.toggle('dark', theme === 'dark');
  root.classList.toggle('light', theme === 'light');

  const meta = document.querySelector('meta[name="theme-color"]');
  meta?.setAttribute('content', THEME_COLOR[theme]);
}
